/* istanbul ignore file */
import axios from '../requester';
import { LINB_API } from '../constants/api-urls';
import moment from 'moment';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';

const formatDate = d => moment(d).format(SEARCH_DATE_FORMAT);

export const getProjectProgressionStatus = async ({
  sensor_authorization_id
}) =>
  await axios.post(LINB_API.PROJET_PROGRESSION.STATUS, {
    sensor_authorization_id
  });

export const getProgressionOverTimeChart = async ({
  version = 'v2',
  sensor_authorization_id,
  after,
  aggregation_period, // month | week
  type, // issues | story_points
  filtersPayload
}) => {
  return await axios.post(LINB_API.PROJET_PROGRESSION.WIDGETS.OVER_TIME_CHART, {
    version,
    sensor_authorization_id,
    before: formatDate(moment()),
    after: formatDate(after),
    aggregation_period,
    type,
    ...(filtersPayload && { ...filtersPayload })
  });
};

export const getInsights = async ({
  version = 'v2',
  sensor_authorization_id,
  before,
  after,
  filtersPayload
}) => {
  return await axios.post(LINB_API.PROJET_PROGRESSION.WIDGETS.INSIGHTS, {
    version,
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after),
    ...(filtersPayload && { ...filtersPayload })
  });
};

export const getProgressionTable = async ({
  version = 'v2',
  sensor_authorization_id,
  before,
  after,
  type,
  issue_type,
  categories, // issue-states: ['created', 'in-progress', 'done']
  limit,
  offset,
  keyword = '',
  insight_id,
  filtersPayload,
  sort_by,
  sort_dir,
  top_assignees
}) => {
  return await axios.post(
    LINB_API.PROJET_PROGRESSION.WIDGETS.PROGRESSION_TABLE,
    {
      version,
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      ...(type && { type }),
      ...(issue_type && { issue_type }),
      ...(!!categories.length && { categories }),
      limit,
      offset,
      ...(keyword.length > 0 && { keyword }),
      ...(!!insight_id && { insight_id }),
      ...(filtersPayload && { ...filtersPayload }),
      ...(sort_by ? { sort_by } : {}),
      ...(sort_dir ? { sort_dir } : {}),
      ...(!!top_assignees && { top_assignees })
    }
  );
};

export const getForecasting = async ({
  version = 'v2',
  sensor_authorization_id,
  after,
  aggregation_period, // month | week
  type, // issues | story_points
  filter_set_id,
  filtersPayload
}) => {
  return await axios.post(LINB_API.PROJET_PROGRESSION.WIDGETS.FORECASTING, {
    version,
    sensor_authorization_id,
    before: formatDate(moment()),
    after: formatDate(after),
    aggregation_period,
    type,
    ...(filter_set_id && { filter_set_id }),
    ...(filtersPayload && { ...filtersPayload })
  });
};
